import type { RouteRecordRaw } from 'vue-router'

import { ensureRootRoutePath, type RedirectRoutePath } from '@/utilities/routers'

const routeUpdatePasswordName = '/update-password'
const routeUpdatePasswordPath = ensureRootRoutePath(routeUpdatePasswordName)

const routeUpdatePassword: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/views/LoginView.vue')
  },
  meta: {
    requireAuth: false,
  },
  name: routeUpdatePasswordName,
  path: routeUpdatePasswordPath,
}

const redirectUpdatePassword: RedirectRoutePath = {
  // use no "name" attribute here, not working with global navigationGuard
  path: routeUpdatePassword.path,
}

export { redirectUpdatePassword, routeUpdatePassword }
